import activitiesReducer from "reducers/activitiesReducer";


export const tableBody = (activities) => {
    
    
    const tbody = []

    for (var i=0;i<activities.length;i++){
        tbody.push(tableRow(activities[i]))
    }
     
    return tbody
}

function tableRow (activity){
    const speed = (activity.distance/activity.duration)*60/1000
    const row = {
        className: "",
        id: activity.id,
        name:activity.name,
        counts:activity.counts,
        activity_type:activity.activity_type,
        subType:activity.sub_type,
        data: [activity.date, activity.duration, activity.distance,speed,activity.avgHr,activity.runningIndex,activity.stressScore,activity.ascent],
    }
    return(row)
}

export const filterActivitiesByType = (activities,state) =>{
    if (state.type === "All"){
        return activities
    }
    if (state.type === "Run"){
        return activities.filter(activity => activity.activity_type =="Run") 
    }
    if (state.type === "Ride"){
        return activities.filter(activity => activity.activity_type =="Ride") 
    }
    if (state.type === "Swim"){
        return activities.filter(activity => activity.activity_type =="Swim") 
    }
    if (state.type === "Other"){
        return activities.filter(activity => activity.activity_type !="Ride" && activity.activity_type !="Run" && activity.activity_type !="Swim") 
    }
}

export const filterActivitiesBySubType = (activities,state) =>{
    if (state.subType === "All"){
        return activities
    }
    if (state.subType === "Race"){
        return activities.filter(activity => activity.sub_type =="Race")
    }
    if (state.subType === "Interval"){
        return activities.filter(activity => activity.sub_type =="Interval")
    }
    if (state.subType === "Threshold"){
        return activities.filter(activity => activity.sub_type =="Threshold")
    }
    if (state.subType === "Aerobic II"){
        return activities.filter(activity => activity.sub_type =="Aerobic II")
    }
    if (state.subType === "Aerobic I"){
        return activities.filter(activity => activity.sub_type =="Aerobic I")
    }
    if (state.subType === "Base"){
        return activities.filter(activity => activity.sub_type =="Base")
    }
    if (state.subType === "None"){
        return activities.filter(activity => activity.sub_type =="None")
    }
}

export const filterActivitiesByInclusion = (activities,state) => {
    if (state.include === "All"){
        return activities
    }
    if (state.include === "True"){
        return activities.filter(activity => activity.counts === true)
    }
    if (state.include === "'false'"){
        return activities.filter(activity => activity.counts === 'false')
    }

}

export const sortActivitiesBy = (activities,state) => {
    if (activities.length<2){
        return []
    }
    if (state.sortBy === "Date"){
        if (state.asc === 'true'){
            return activities.sort((a, b) =>new Date(a.date) -new Date(b.date));
        }
        else{
            return activities.sort((a, b) =>new Date(b.date) -new Date(a.date));
        }
    }
    if (state.sortBy === "Duration"){
        if (state.asc === 'false'){
            return activities.sort((a, b) => parseFloat(a.duration) - parseFloat(b.duration));
        }
        else{
            return activities.sort((a, b) =>parseFloat(b.duration) - parseFloat(a.duration) );
        }
    }
    if (state.sortBy === "Distance"){
        if (state.asc === 'false'){
            return activities.sort((a, b) => parseFloat(a.distance) - parseFloat(b.distance));
        }
        else{
            return activities.sort((a, b) =>parseFloat(b.distance) - parseFloat(a.distance) );
        }
    }
    if (state.sortBy === "Perf Index"){
        if (state.asc === 'false'){
            return activities.sort((a, b) => parseFloat(a.runningIndex) - parseFloat(b.runningIndex));
        }
        else{
            return activities.sort((a, b) =>parseFloat(b.runningIndex) - parseFloat(a.runningIndex) );
        }
    }
    if (state.sortBy === "Stress Score"){
        if (state.asc === 'false'){
            return activities.sort((a, b) => parseFloat(a.stressScore) - parseFloat(b.stressScore));
        }
        else{
            return activities.sort((a, b) =>parseFloat(b.stressScore) - parseFloat(a.stressScore) );
        }
    }
    if (state.sortBy === "Elevation"){
        if (state.asc === 'false'){
            return activities.sort((a, b) => parseFloat(a.ascent) - parseFloat(b.ascent));
        }
        else{
            return activities.sort((a, b) =>parseFloat(b.ascent) - parseFloat(a.ascent) );
        }
    }
}